import { useReducer } from 'react';
import {
    type LanguagePackFilteringRule,
    LanguagePackSortingField,
    type LanguagePackSortingRule,
    SortingOrder,
} from '../../../api/types';
import { pageReducer, type PageState, type PageAction } from '../../../components/PaginatedTable';
import { type SortOrderValue, TableSortingOrder } from '../../../utilities/useSortAndFilterCache';

type SortRule = LanguagePackSortingRule & SortOrderValue;

type State = PageState & {
    sort: SortRule;
    filter: LanguagePackFilteringRule;
};

type SetSortAction = { type: 'setSort'; sortBy: SortRule };
type SetFilterAction = { type: 'setFilter'; filteringRule: LanguagePackFilteringRule };
type Action = PageAction | SetSortAction | SetFilterAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setSort':
            return { ...state, page: 1, sort: action.sortBy };

        case 'setFilter':
            return { ...state, page: 1, filter: action.filteringRule };

        default:
            return pageReducer(state, action);
    }
};

export const defaultLanguagePackListSort = {
    field: LanguagePackSortingField.ReferenceName,
    order: SortingOrder.Asc,
    orderValue: TableSortingOrder.Asc,
};

const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        // default pagination
        page: 1,
        pageSize: 10,

        // default sorting
        sort: cache?.sort || defaultLanguagePackListSort,
        filter: cache?.filter || {},
    });

export default useListReducer;
